import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import TabComponent from "~/components/TabComponent";
import Wrapper from "~/shared/ui/Wrapper";
import { useGetLocationData } from "~/hooks/locationData";
import { usePermissions } from "~/shared/context/PermissionContext";

import Agreements from "./Agreements";
import Contracts from "./Contracts";
import ListOfDocumentsFilter from "./Filter";

export interface AccessIProps {
  create: boolean;
  edit: boolean;
  history: boolean;
  print?: boolean;
}

const ListOfDocuments = () => {
  const { t } = useTranslation();
  const { selected } = useGetLocationData();
  const [access, setAccess] = useState<AccessIProps>(null);
  const { hasPermission, loading } = usePermissions();

  useEffect(() => {
    if (!loading) {
      setAccess({
        create: hasPermission("contracts.createContracts"),
        edit: hasPermission("contracts.editContracts"),
        history: hasPermission("contracts.history"),
        print: hasPermission("contracts.print"),
      });
    }
  }, [loading]);

  const tabs = [
    {
      permission: "contracts.dealers",
      id: "contracts",
      label: t("registryOfDocs.contractsTab"),
    },
    {
      permission: "contracts.dealers",
      id: "agreements",
      label: t("registryOfDocs.agreementsTab"),
    },
  ];

  return (
    <Wrapper.Content title={t("registryOfDocs.title")}>
      <TabComponent
        tabs={tabs}
        horizontal="start"
        vertical="end"
        fontSize="16"
      />
      <ListOfDocumentsFilter />
      {selected === "contracts" && <Contracts access={access} />}
      {selected === "agreements" && <Agreements access={access} />}
    </Wrapper.Content>
  );
};

export default ListOfDocuments;
